import { AdyenRouteConfig, AdyenRoutes } from "./route-config";
import { AdyenRoutesName } from "./route-names";

export const getRoutePath = (routeName: AdyenRoutesName) => {
  const route: AdyenRouteConfig = AdyenRoutes[routeName];
  return route.path;
};

export const getRoutePermission = (routeName: AdyenRoutesName) => {
  const route: AdyenRouteConfig = AdyenRoutes[routeName];
  return route.permission || undefined;
};
